export const DESKTOP_MIN_WIDTH = 1024;
export const DESKTOP_LARGE_MIN_WIDTH = 1920;
